
import styles from './index.module.scss'
import Utils from '@utils/utils'
import Iconfont from '@utils/Iconfont';
import { Image, Upload } from 'antd';
import { useState } from 'react';
import API from "@api/api";


const TableUploadView = (props) => {
    const { url, type, width, item, projectId, onReupload, isEdit } = props
    const [visible, setVisible] = useState(false);

    const deleteImage = async () => {
        const updatedInputImages = type == 'mainImg' ?
            item.inputImages.filter(item => item.mainImage === false) :
            item.inputImages.filter(item => item.mainImage === true)
        const saveRes = await API.batchSaveSku([{
            ...item,
            inputImages: updatedInputImages,
            projectId
        }])
        if (saveRes?.code === 0) props.listSkuByProject(isEdit ? paramsData : null)
    }


    return (
        <div className={styles.TableUploadView}>
            <div className={styles.ImageCell} style={{ width: width }} >
                <img src={Utils.getImgThumbnail(url)} alt="" />
                {
                    !isEdit && <div className={styles.maskBox}>
                        <p onClick={() => setVisible(true)}><Iconfont className={styles.Icon} type="icon-FullscreenOutlined" /><span>查看大图</span></p>
                        <p onClick={() => {
                            const input = document.createElement('input');
                            input.type = 'file';
                            input.accept = 'image/jpeg,image/png,image/webp,image/avif';
                            input.onchange = (e) => {
                                const file = e.target.files[0];
                                if (file && onReupload) {
                                    console.log(file)
                                    onReupload(file, [file], item, type)
                                }
                            };
                            input.click();
                        }}><Iconfont className={styles.Icon} type="icon-ReuploadOutlined" /><span>重新上传</span></p>
                        {type != 'mainImg' && <p onClick={() => deleteImage()}><Iconfont className={styles.Icon} type="icon-DeleteOutlined" /><span>删除图片</span></p>}
                    </div>
                }

            </div>

            <Image
                // width={200}
                style={{ display: 'none' }}
                src={Utils.getImgThumbnail(url)}
                preview={{
                    visible,
                    src: Utils.getImgThumbnail(url),
                    onVisibleChange: value => {
                        setVisible(value);
                    },
                }}
            />
        </div>
    )
}

export default TableUploadView